/**
 * Shared Module Configuration for Subscription Plans
 */
export const MODULE_CONFIG = {
  title: "Subscription Plans",
  subtitle: "Configure subscription pricing tiers, platform limits, QuickBooks connectors, and features.",
  routeBase: "/plans",
  endpoints: {
    listing: "plans/listing",
    detail: "plans/detail",
    add: "plans/add",
    update: "plans/update",
    statusChange: "plans/status/change",
    delete: "plans/delete",
  },
  statusMap: {
    active: {
      label: "Active",
      bgClass: "bg-emerald-50 text-emerald-700 border-emerald-200/90 font-bold",
      dotClass: "bg-emerald-500",
    },
    deactive: {
      label: "Deactive",
      bgClass: "bg-slate-100 text-slate-600 border-slate-200 font-bold",
      dotClass: "bg-slate-400",
    },
    inactive: {
      label: "Inactive",
      bgClass: "bg-slate-100 text-slate-600 border-slate-200 font-bold",
      dotClass: "bg-slate-400",
    },
  },
  integrationMap: {
    QBO: {
      label: "QuickBooks Online",
      badgeClass: "bg-blue-50 text-[#115B9D] border-blue-200",
      shortLabel: "QBO",
    },
    QBD: {
      label: "QuickBooks Desktop",
      badgeClass: "bg-amber-50 text-amber-800 border-amber-200",
      shortLabel: "QBD",
    },
    BOTH: {
      label: "Hybrid (QBO & Desktop)",
      badgeClass: "bg-indigo-50 text-indigo-700 border-indigo-200",
      shortLabel: "Hybrid (Both)",
    },
    NONE: {
      label: "Stand-Alone",
      badgeClass: "bg-slate-50 text-slate-600 border-slate-200",
      shortLabel: "None",
    },
  },
};
